export default __webpack_public_path__ + "assets/images/ba800c5d14efe29b534d95605037c61b.svg";